import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import { ToastService } from 'libs/mdbootstrap/typescripts/pro';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import * as Models from 'app/core/models';
import { UserService } from 'app/core/user/user.service';
import { LookupService } from 'app/core/lookup/lookup.service';
import { ModalService } from 'app/modal/modal.service';
import { ProcessService } from 'app/core/process/process.service';

@Component({
  selector: 'app-complete-process-modal',
  templateUrl: './completeProcessModal.component.html',
  styleUrls: ['./completeProcessModal.component.scss']
})

export class CompleteProcessModalComponent implements OnInit, Models.ModalComponent {

  @ViewChild('modalCompleteExecutionProcess') public contentModal: any;
  isLoading = false;
  showForm = false;
  showError = false;
  error: any = null;
  isLikeLoading = false;
  processTitle: string;
  processId: number;
  processCoverUrl: string;
  mode: Models.Process_Complete_Mode;
  canLike: boolean;
  hasLiked: boolean;
  generalErrMsg: string;
  isRtl: boolean = false;

  constructor(private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router,
    private lookupService: LookupService,
    private modalService: ModalService,
    private processService: ProcessService,
    private toastrService: ToastService,
    private translateService: TranslateService) {
  }

  ngOnInit() {
    this.isLoading = false;
    this.showForm = false;
    this.showError = false;
    this.error = null;
    this.isLikeLoading = false;

    this.translateService.get('PROCESS.COMPLETED_MODAL.GENERAL_ERROR').subscribe((translatedMsg) => {
      this.generalErrMsg = translatedMsg;
    });
  }

  openCompleteExecutionProcessModal() {
    this.contentModal.show();
  }

  closeCompleteExecutionProcessModal() {
    this.contentModal.hide();
  }

  closeModal() {
    this.closeCompleteExecutionProcessModal();
  }

  done() {
    const data: Models.ModalContext = {
      modalType: Models.ModalType.PROCESS_COMPLETE,
      modalAction: Models.ModalAction.CLOSE,
      parameters: []
    };
    this.modalService.command(data);
    this.router.navigate(['/home']);
  }

  openModal(data: any[]): void {
    this.mode = data[0];
    this.processTitle = data[1];
    this.processId = data[2];
    this.processCoverUrl = data[3];
    this.canLike = data[4];
    this.hasLiked = data[5];
    this.isRtl = data[6];

    this.isLoading = true;
    this.showError = false;
    this.showForm = false;
    this.error = null;
    this.isLikeLoading = false;

    this.openCompleteExecutionProcessModal();
  }

  like(): void {
    this.isLikeLoading = true;
    this.processService.likeProcess(this.processId)
      .finally(() => {
        this.isLikeLoading = false;
      })
      .subscribe(() => {
        this.error = undefined;
        this.hasLiked = true;
      }, error => {
        this.error = error;
        this.toastrService.error(this.errorMessage);
      });
  }

  get errorMessage(): string {
    if (this.error) {
      const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
      if (errorBody && errorBody.error) {
        return errorBody.error;
      }
    }
    return this.generalErrMsg;
  }

  // Share Buttons
  get shareRepoUrl(): string {
    let url = window.location.origin + '/process/preview/';
    url += this.processId ? this.processId.toString() : '';
    url += this.processTitle && this.processTitle.trim() ? '/' + encodeURI(this.processTitle) : '';
    return url;
  }

  get shareImageUrl(): string {
    // @TODO: move ro config file
    return this.processCoverUrl ? this.processCoverUrl : 'http://proactiview-client.azurewebsites.net/assets/images/logo.png';
  }

  get shareText(): string {
    return this.processTitle ? this.processTitle : 'ProactView';
  }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/completeProcessModal/completeProcessModal.component.ts